import { applySnapshot, flow, types } from "mobx-state-tree";

import api from "services/api";

const TagItem = types.model({
  id: types.number,
  title: types.string,
});

const TagsStore = types
  .model({
    items: types.array(TagItem),
    isLoading: types.optional(types.boolean, false),
    isManaging: types.optional(types.boolean, false),
  })
  .actions(self => ({
    fetch: flow(function*() {
      self.isLoading = true;

      try {
        const { items } = yield api.get(`/tag/slim-list`);
        applySnapshot(self, { ...self, items });
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),

    addTags: flow(function*(payload: any) {
      self.isManaging = true;

      try {
        yield api.post(`/tag`, payload);
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isManaging = false;
      }
    }),

    deleteTags: flow(function*(payload: any) {
      self.isManaging = true;

      try {
        yield api.delete(`/tag`, payload);
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isManaging = false;
      }
    }),

    reset() {
      applySnapshot(self, { items: [] });
    },
  }));

export default TagsStore.create();
